import { render } from "./DedicateDomain.vue?vue&type=template&id=3bf2a8cf&scoped=true"
import script from "./DedicateDomain.vue?vue&type=script&lang=js"
export * from "./DedicateDomain.vue?vue&type=script&lang=js"

import "./DedicateDomain.vue?vue&type=style&index=0&id=3bf2a8cf&scoped=true&lang=scss"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf2a8cf"]])

export default __exports__